import { c as _c } from "react/compiler-runtime";
import { MemeCalendarOverviewNextMint } from "@/components/meme-calendar/MemeCalendarOverview";
import NotFound from "@/components/not-found/NotFound";
export default function UpcomingMemePage(t0) {
  const $ = _c(3);
  const {
    id
  } = t0;
  const numId = Number(id);
  if (Number.isInteger(numId)) {
    let t1;
    if ($[0] !== numId) {
      t1 = <div className="tw-mt-6"><MemeCalendarOverviewNextMint displayTz="local" id={numId} /></div>;
      $[0] = numId;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NotFound label="MEME" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}